module.exports = require("@splunk/react-ui/Paginator");